import { render, staticRenderFns } from "./DodFilters.vue?vue&type=template&id=68308c8e&scoped=true&"
import script from "./DodFilters.vue?vue&type=script&lang=js&"
export * from "./DodFilters.vue?vue&type=script&lang=js&"
import style0 from "./DodFilters.vue?vue&type=style&index=0&id=68308c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68308c8e",
  null
  
)

export default component.exports